import { render, staticRenderFns } from "./Alamat.vue?vue&type=template&id=37300542&"
import script from "./Alamat.vue?vue&type=script&lang=js&"
export * from "./Alamat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports